import { CanActivate, Router } from "@angular/router";
import { AuthService } from "../_services/auth.service";
import { NotificationService } from "../_services/notification.service";
import { Injectable } from "@angular/core";

@Injectable({
    providedIn: 'root'
})
export class TollDistributerGuard implements CanActivate {

    private _srbTollDistributerRole = 3;

    constructor(
        private authService: AuthService, 
        private router: Router,
        private notify: NotificationService
    ) { }

    canActivate(): boolean {
        return this.isLoggedInAsTollDistributer() || this.navigateLogin();
    }  

    private isLoggedInAsTollDistributer(): boolean {
        const isLoggedIn = this.authService.isLoggedInTollDistributer(),
              tollDistributerUser = this.authService.getTollDistributerUser(),
              isClientIdValid = tollDistributerUser?.clientId > 0,
              isDistributerRole = tollDistributerUser?.role === this._srbTollDistributerRole;
        return isLoggedIn && isClientIdValid && isDistributerRole;
    }

    private navigateLogin(): boolean {
        this.notify.warning('Morate se ulogovati');
        this.router.navigateByUrl('/login');
        return false;
    }
}
